export const REPORT_DATA = "REPORT_DATA";
export const GET_REPORT_DATA = "GET_REPORT_DATA";
export const SET_360_VIEW_DATA = "SET_360_VIEW_DATA";